document.addEventListener('DOMContentLoaded', function () {

  const breadcrumbParent =
    document.getElementById('EssntlBreadcrumbParent');

  if (!breadcrumbParent) return;

  const referrer = document.referrer;

  if (!referrer) return;

  try {

    const referrerUrl = new URL(referrer);

    // Only process referrers from ESSNTL itself
    if (referrerUrl.origin !== window.location.origin) {
      return;
    }

    const pathParts =
      referrerUrl.pathname.split('/').filter(Boolean);

    // We only care about collection pages
    if (
      pathParts.length >= 2 &&
      pathParts[0] === 'collections'
    ) {

      const collectionHandle = pathParts[1];

      // Ignore /collections/all
      if (collectionHandle === 'all') {
        return;
      }

      /*
       * Convert:
       *
       * woody-perfumes -> Woody Perfumes
       * citrus-perfumes -> Citrus Perfumes
       *
       */
      const collectionName = collectionHandle
        .split('-')
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');

      breadcrumbParent.href =
        '/collections/' + collectionHandle;

      breadcrumbParent.textContent =
        collectionName;
    }

  } catch (error) {

    console.warn(
      'ESSNTL breadcrumb error:',
      error
    );

  }

});